import { useEffect } from 'react'
import { Box, Heading, Text, SimpleGrid, Flex } from '@chakra-ui/react'
import { Building2, ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useProperties } from '@/features/properties/hooks/useProperties'
import { LoadingState } from '@/shared/components/LoadingState'

export function AccountingSelectResidencePage() {
  const navigate = useNavigate()
  const { data: residences, isLoading } = useProperties()

  // Si une seule résidence, rediriger directement
  useEffect(() => {
    if (!isLoading && residences?.length === 1) {
      navigate(`/app/accounting/${residences[0]!.id}`, { replace: true })
    }
  }, [isLoading, residences, navigate])

  if (isLoading) {
    return <LoadingState />
  }

  if (!residences || residences.length === 0) {
    return (
      <Box p={6} textAlign="center">
        <Building2 size={48} style={{ margin: '0 auto 16px', color: '#718096' }} />
        <Heading size="lg" mb={2}>Aucune résidence</Heading>
        <Text color="gray.600">
          Créez une résidence pour accéder au module comptabilité.
        </Text>
      </Box>
    )
  }

  // Redirection en cours pour une seule résidence
  if (residences.length === 1) {
    return <LoadingState />
  }

  return (
    <Box p={6}>
      <Heading size="xl" mb={2}>Comptabilité</Heading>
      <Text color="gray.600" mb={6}>
        Sélectionnez une résidence pour accéder à sa comptabilité
      </Text>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={4}>
        {residences.map((residence) => (
          <Box
            key={residence.id}
            p={5}
            bg="white"
            borderRadius="lg"
            boxShadow="sm"
            border="1px solid"
            borderColor="gray.200"
            cursor="pointer"
            _hover={{ borderColor: 'brand.400', boxShadow: 'md' }}
            transition="all 0.2s"
            onClick={() => navigate(`/app/accounting/${residence.id}`)}
          >
            <Flex justify="space-between" align="start">
              <Box>
                <Heading size="md" mb={1}>{residence.name}</Heading>
                <Text fontSize="sm" color="gray.500">
                  {residence.address}
                </Text>
              </Box>
              <ArrowRight size={20} color="#718096" />
            </Flex>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  )
}
